
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#1C2F45","stroke-linecap":"round","stroke-linejoin":"round","clip-path":"url(#clip0_22175_7082)"}},[_c('path',{attrs:{"d":"M9.492 1.966l.616-.611c.543-.539 1.429-.56 1.98-.046l.637.595c.551.513.558 1.366.015 1.905l-.644.64M2.34 9.64l2.11 1.983"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M2.905 12.562l-2.068.63.585-2.025 1.483 1.395z"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M1.891 9.522l7.554-7.55 1.332 1.25 1.352 1.232-7.554 7.551-3.738 1.186 1.054-3.669z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_22175_7082"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    